<template>
<div v-if="show" :class="add_margin?'add_margin':'add_margin-no'" id="printMe">
    <v-card class="pa-1 elevation-0" >
        <v-icon style="float: right" class="hidden-print-only" @click="emitToParent('close')" >mdi-close-circle</v-icon>
          <v-icon style="float: right" class="hidden-print-only" @click="Print()" >mdi-printer</v-icon>
        <print-header/>
                 <v-row class="caption font-weight-bold" no-gutters>
                     DAILY SALE REPORTS 
                     <v-spacer/>
                     FISHCAR: {{fishcar.name}} 
                     <v-spacer/>
                     <span class="mr-5">{{selected_date}} </span>
                 </v-row>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="headers"
                                :items-per-page="10000"
                                hide-default-footer
                                :items="TRANSACTIONS"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                         
                                        <td>
                                            {{item.customer_name}}

                                        </td>
                                        <td>{{ item.name }} </td>
                                        <td class="text-right">
                                            <template v-if="ISADMIN">
                                                <input class="hidden-print-only" v-model="item.kilos" style="width: 48px;" /><span  class="hidden-screen-only">{{item.kilos}}</span>
                                            </template>
                                            <template else>
                                                    {{item.kilos}}
                                            </template>
                                        </td>
                                        <td class="text-right">
                                             <template v-if="ISADMIN">
                                                <input class="hidden-print-only" v-model="item.price" style="width: 48px;" /><span  class="hidden-screen-only">{{item.price}}</span>
                                             </template>
                                              <template else>
                                                    {{item.price}}
                                            </template>
                                        </td>
                                    <td class="text-right">
                                        <span v-if="item.payment_type=='cash'">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</span>
                                    </td>
                                        <td class="text-right">
                                        <span v-if="item.payment_type=='credit'">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</span>
                                        </td>
                                        <td class="text-right">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</td>
                                    </tr>
                                        <tr>
                                            <td colspan="2" class="text-left font-weight-bold">TOTAL:</td>
                                            <td class="text-right font-weight-bold">{{$money(TOTAL_KILOS)}}</td>
                                            <td></td>
                                            <td class="text-right font-weight-bold">{{$money(TOTAL_CASH)}}</td>
                                            <td class="text-right font-weight-bold">{{$money(TOTAL_CREDIT)}}</td>
                                            <td class="text-right font-weight-bold">{{$money(TOTAL_CASH + TOTAL_CREDIT)}}</td>
                                        </tr>
                                     </tbody>
                                </template>
                                </v-data-table>
                    
     
        <v-row no-gutters class="mt-4">
            <v-col sm="9" id="table-summary">
                 <div class="caption font-weight-bold">SUMMARY</div>
                            <v-data-table
                                class="va-table"
                                dense
                                :headers="headers2"
                                :items-per-page="10000"
                                hide-default-footer
                                :items="SALES_SUMMARIES"
                                >

                                 <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                        <td>{{item.fish}}</td>
                                        <td class="text-right">{{$money(item.kilos)}}</td>
                                        <td class="text-right">{{$money(item.price)}}</td>
                                        <td class="text-right">{{$money($IsNum(item.kilos) * $IsNum(item.price))}}</td>
                                    </tr>
                                        <tr>
                                            
                                            <td class="text-left font-weight-bold">TOTAL:</td>
                                            <td class="text-right font-weight-bold">{{$money(TOTAL_KILOS)}}</td>
                                            <td></td>
                                            <td class="text-right font-weight-bold">{{$money(TOTAL_CASH + TOTAL_CREDIT)}}</td>
                                        </tr>
                                       </tbody>
                                </template>

                                </v-data-table>
            </v-col>
             <v-col sm="3" id="table-tlc">
                 <div style="float: right;"> 
                     <div class="caption font-weight-bold">TCL</div>
                        <table class="va-table dense mt-2">
                            <tbody>
                                <tr>
                                    <td class="pa-1">TICKET:</td>
                                    <td class="pa-1" style="width: 32px;"><input  class="hidden-print-only" v-model="ticket" style="width: 48px;"/><span  class="hidden-screen-only">{{ticket}}</span></td>
                                </tr>
                                <tr>
                                    <td class="pa-1">PARKING:</td>
                                    <td class="pa-1" style="width: 32px;"><input class="hidden-print-only" v-model="parking" style="width: 48px;"/><span class="hidden-screen-only">{{parking}}</span></td>
                                </tr>
                                <tr>
                                    <td class="pa-1">LABOR:</td>
                                    <td class="pa-1" style="width: 32px;"><input  class="hidden-print-only" v-model="labor" style="width: 48px;"/><span  class="hidden-screen-only">{{labor}}</span></td>
                                </tr>
                                <tr>
                                    <td class="pa-1">COMM:</td>
                                    <td class="pa-1" style="width: 32px;"><input class="hidden-print-only" v-model="commission" style="width: 48px;" /><span  class="hidden-screen-only">{{commission}}</span></td>
                                     <td class="pa-1 font-weight-bold">{{$money(TOTAL_DEDUCTION)}}</td>
                                </tr>
                                
                                    <tr>
                                    <td class="pa-1 font-weight-bold text-right net-sales" colspan="3"> NET SALES: {{$money(TOTAL_NET)}}</td>
                                </tr>
                            </tbody>
                        </table>
                 </div>
            </v-col>
        </v-row>
    </v-card>
</div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
         tcl: {
            type: Object,
            default: ()=> { return {} }
        },
        fishcar: {
            type: Object,
            default: ()=> { return {} }
        },
        selected_date: {
            type: String,
            default: ''
        }
    },
      mixins: [API_MIXINS],
    watch: {
        show(v) {
            if(v) {
                this.getTransactions()
            } else {
                console.log("checking!")
            }
        }
    },
    data: () => ({
        ticket:0,
        parking:0,
        add_margin: true,
        labor: 0,
        commission:0,
        copied_data:[],
        selected_fishcar:{},
         headers: [
            { text: 'Customer', value:'customer', sortable: false },
            { text: 'Kind', value:'kind', sortable: false },
            { text: 'Kilos', value:'kilos' , sortable: false, align: 'right'},
            { text: 'Price', value:'Price' , sortable: false, align: 'right'},
            { text: 'Cash', sortable: false, align: 'right'},
            { text: 'Credit', sortable: false, align: 'right'},
            { text: 'Total', sortable: false, align: 'right'},
        ],
         headers2: [
            { text: 'Kind', value:'kind', sortable: false},
            { text: 'Kilos', value:'kilos', sortable: false,align: 'right'},
            { text: 'Price', value:'price', sortable: false,align: 'right'},
            { text: 'Total', sortable: false, align: 'right'},
        ],
         headers3: [
            { text: 'ITEM',align: 'right' },
            { text: 'AMOUNT',align: 'left'},
        ],
    }),
    computed:{
      TRANSACTIONS() {
         if (this.copied_data != null) {
             return this.copied_data
         } else {
             return this.$store.state.todays_transactions
         }
        
         // return this.$store.state.todays_transactions
      },
      TOTAL_KILOS() {
        let total = 0
        let items = this.TRANSACTIONS
        for(var i= 0;i< items.length;i++) {
             total += this.$IsNum(items[i].kilos)
        }
        return total
      },
      TOTAL_CASH() {
        let total = 0
        let items =  this.TRANSACTIONS
        for(var i= 0;i< items.length;i++) {
            if(items[i].payment_type == "cash") {
                total += this.$IsNum(items[i].kilos) * this.$IsNum(items[i].price)
            }
        }
        return total
      },
       TOTAL_CREDIT() {
        let total = 0
        let items =  this.TRANSACTIONS
        for(var i= 0;i< items.length;i++) {
            if(items[i].payment_type == "credit") {
                total += this.$IsNum(items[i].kilos) * this.$IsNum(items[i].price)
            }
        }
        return total
      },
        KINDS(){
            var groupBy = this.$groupBy('name')
            var fish = groupBy(this.TRANSACTIONS)
            return fish
        },
        SALES_SUMMARIES() {
            var obj = this.KINDS
            var result = []
            for (let key in obj){
                if(obj.hasOwnProperty(key)){
                   result = result.concat(this.groupByPrice(key, obj[key]))
                }
            }
            this.allPrices(result)
            return  result
        },
        TICKET(){
            var add = this.$IsNum(this.getSettingVal('ticket_add'))
            return ((this.$IsNum(this.TOTAL_KILOS) * this.$IsNum(this.getSettingVal('ticket_multiplier')) ) + add).toFixed(0)
        },
        LABOR() {
            var kilos = this.TOTAL_KILOS
             var labor1 = this.$IsNum(kilos) * this.$IsNum(this.getSettingVal('labor_1_multiplier'))
             var labor2 = (this.$IsNum(kilos) * this.$IsNum(this.getSettingVal('labor_2_multiplier'))) * this.$IsNum(this.MIDPRICE) + this.$IsNum(kilos)
            return (labor2 + labor1).toFixed(0)
        },
        MIDPRICE(){
             return this.$store.state.midprice
        },
        COMMISSION(){
            var sales = this.TOTAL_CASH + this.TOTAL_CREDIT
            var comm = this.$IsNum(this.selected_fishcar.commission)/100
            return (this.$IsNum(sales) * comm).toFixed(0)
        },
        CASH_SERVICE_CHARGE() {
            var sc = this.$IsNum(this.getSettingVal('service_charge'))
            var arr = this.TRANSACTIONS
            let filter = arr.reduce((a, o) => o.payment_type=='cash'?a += this.$IsNum(o.kilos)*sc:a+=0, 0)
            return filter
        },
        CREDIT_SERVICE_CHARGE() {
            var sc = this.$IsNum(this.getSettingVal('service_charge'))
             var arr = this.TRANSACTIONS
            let filter = arr.reduce((a, o) => o.payment_type=='credit'?a += this.$IsNum(o.kilos)*sc:a+=0, 0)
            return filter
        },
        TOTAL_DEDUCTION(){
            return  this.$IsNum(this.ticket) + this.$IsNum(this.parking) + this.$IsNum(this.labor) + this.$IsNum(this.commission)
        },
        TOTAL_NET(){
            var total = this.TOTAL_CASH + this.TOTAL_CREDIT
            return total - this.TOTAL_DEDUCTION
        },
        ISADMIN(){
        if(this.$session.get('role') == 'administrator') {
            return true
        } 
        return false
      },
    },
    methods: {
              ...mapMutations(['setAlert', 'setDrawer', 'setAlertText', 'setLoggedIn', 'setTodaysTransactions', 'setMidprice']),
       emitToParent (action) {
           
            this.$emit('DialogEvent', action)
    },
    Print(){
        this.add_margin=false
        setTimeout(()=>{this.$printThis()}, 500)
       //this.$htmlToPaper('printMe')
    },
       allPrices(PriceArr){
           let filter = PriceArr.reduce((a, o) => a.concat(this.$IsNum(o.price)), [])
          var prices = filter.sort(function(a, b){return a-b})
           if((prices.length % 2) > 0) {
               this.setMidprice(prices[Math.floor(prices.length/2)])
          } else {
            this.setMidprice(prices[(prices.length / 2) - 1])
          }
          this.setCharges()
        },
      groupByPrice(fish, arr){
           var groupBy = this.$groupBy('price')
            var obj = groupBy(arr)
            var result = []
            for (let key in obj){
                if(obj.hasOwnProperty(key)){
                  result.push({fish: fish, price:key, kilos:this.sumWeight(obj[key])})
                }
            }
          return result
      },
      sumWeight(obj){
            var weight = 0
            for (var i=0;i<obj.length;i++){
                weight += this.$IsNum(obj[i].kilos)
            }
            return weight
      },
      getTransactions(){
         // this.GET_TRANSACTIONS({param1: this.selected_date})
          console.log('getcopy to print')
          this.getcopy()
      },
      getcopy(){
          var param = {
                fishcar: this.fishcar.name,
                trans_date: this.selected_date
          }
          console.log('getcopy print')
         this.$http.post("clone/get", param).then(response => {
               response.data.status?this.copied_data=response.data.data.sales_data:this.copied_data=[]
            }).catch(e => {
            console.log(e.data)
          }) 
     },
      FilterTransactions() {
        this.sales_summary_items=[]
        var result = []
        let items = this.$store.state.qued_transactions
        for(var i= 0;i< items.length;i++) {
            if(items[i].supplier == this.selected_fishcar.id) {
              result.push(items[i])
            }
        }
        this.setTodaysTransactions(result)
        //setTimeout(()=> {this.setCharges()} , 1000)
      },
      setCharges() {
       
        this.ticket = this.tcl.ticket
            this.parking= this.tcl.parking
            this.labor= this.tcl.labor
            this.commission= this.tcl.commission
          
      },
      getCustomers: function() { 
          this.$http.post("customer/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.customers = response.data.data:this.customers = []
          }).catch(e => {
           console.log(e.data)
         })
     }
    }
  }
</script>
<style>
    .add_margin {
        margin-left: 270px
    }
</style>